// extracted by mini-css-extract-plugin
export var change = "_42-1";
export var changeList = "_42-0";
export var changePath = "_42-2";
export var diffArrow = "_42-5";
export var diffRow = "_42-3";
export var diffValue = "_42-4";
export var error = "_42-8";
export var notice = "_42-9";
export var result = "_42-6";
export var success = "_42-7";